import { Components, Theme } from '@mui/material/styles';

export const muiListSubheaderOverride: Components<Omit<Theme, 'components'>>['MuiListSubheader'] = {
  defaultProps: {
    classes: {
      root: 'text-[0.875rem] text-text-80 font-bold'
    }
  }
};
